import React, { useEffect, useRef, useState } from "react";

/**
 * Fades + lifts its children into view the first time they scroll on-screen.
 * Lightweight (IntersectionObserver + CSS transition), safe to wrap around
 * heavy sections without the freeze issues a JS-animated approach can hit.
 */
const ScrollReveal: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setShown(true);
          io.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={
        "transition-all duration-700 ease-out " +
        (shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8") +
        (className ? " " + className : "")
      }
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
